import React, { useContext, useEffect, useState } from 'react'
import AccessSuccessModal from '../../../components/modal/submit-success-modal'
import { forgotPassword } from '../../../utils/images/imagepath'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { end_points } from '../../../services/end_points/end_points'
import { ApiServiceContext } from '../../../utils/shared.module'
import {} from 'react-router-dom'
import { email } from '../../../services/core.index'

import { logo, logoSmall } from '../../../utils/images/imagepath'

const forgotPasswordFormSchema = yup.object({
  email: yup
    .string()
    .required('Email address is required')
    .matches(email, 'Enter a valid email address')
    .max(64)
    .trim(),
})

const ForgotPassword = () => {
  const navigate = useNavigate()
  const layoutsettings = useSelector((state: any) => state?.layoutsettings)
  const { postData } = useContext(ApiServiceContext)
  const [showModal, setShowModal] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [Email, setEmail] = useState<string>('')

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgotPasswordFormSchema),
  })

  const onOkayModal = () => {
    reset()
    // navigate('/auth/reset-password')
    navigate('/auth/otp')
  }

  const onSubmit = async (data: any) => {
    try {
      const urls = end_points.forgotPassword.url
      const response = await postData(urls, {
        email: data?.email,
      })
      // console.log(response.data.response.responseMessage);
      if (response.status == 200) {
        setEmail(data?.email)
        setShowModal(true)
      } else {
        setError(true)
        setErrorMessage(response.data.errors[0].msg)
        setShowModal(false)
      }
    } catch (e) {}
  }

  return (
    // <div className='loginbox'>
    //   <div className='login-right'>
    //     <div className='login-right-wrap'>
    //       <div className='login-header'>
    //         <h1>{layoutsettings?.application_title || 'CRM'}</h1>
    //         <h4>
    //           Forgot Password? <img src={forgotPassword} alt='img' />
    //         </h4>
    //         <p className='account-subtitle'>
    //           Enter your email, and we'll send you instructions to reset your
    //           password
    //         </p>
    //       </div>
    //       {/* Form */}
    //       <form onSubmit={handleSubmit(onSubmit)}>
    //         <div className='form-wrap'>
    //           <label>Email</label>
    //           <Controller
    //             name='email'
    //             control={control}
    //             render={({ field: { value, onChange } }) => (
    //               <input
    //                 className={`form-control  ${
    //                   errors?.email ? 'error-input' : ''
    //                 }`}
    //                 type='text'
    //                 value={value || ''}
    //                 onChange={onChange}
    //                 autoComplete='false'
    //                 placeholder='Enter email'
    //                 maxLength={64}
    //               />
    //             )}
    //             defaultValue=''
    //           />
    //           <small className='error-input'>{errors?.email?.message}</small>{' '}
    //         </div>
    //         <div className='form-wrap mb-0'>
    //           <button className='btn btn-primary btn-block mb-3' type='submit'>
    //             Send Reset Link
    //           </button>
    //           <Link
    //             to='/auth/login'
    //             className='text-primary d-block text-center'
    //           >
    //             <i className='ti ti-chevron-left ms-2' /> Back to log in
    //           </Link>
    //         </div>
    //       </form>
    //       {/* /Form */}
    //     </div>
    //   </div>
    //   {error && (
    //     <div className='alert alert-danger' role='alert'>
    //       {errorMessage}
    //     </div>
    //   )}
    //   <AccessSuccessModal
    //     setShowModal={setShowModal}
    //     showModal={showModal}
    //     content='We sent a password reset link to'
    //     email={Email}
    //     title='Check your email'
    //     onOk={onOkayModal}
    //   />
    // </div>
    <div className='main-wrapper base-wrapper'>
      <div className='forgot-page-wrapper'>
        <div className='forgot-page-container'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='static-page'>
                  <div className='row'>
                    <div className='col-12 col-md-10 col-lg-6 offset-md-1 offset-lg-3'>
                      <div className='forgot-pwd-topper'>
                        <div className='forgot-pwd text-center'>
                          <img src={logo} />
                          <div className='forgot-password-inner'>
                            <div className='forgot-password-title text-center'>
                              <h5>Forgot Password</h5>
                              <p>
                                Enter your email and we'll send you a OTP to
                                reset your password.
                              </p>
                            </div>
                            <div className='forgot-password-form mt-3'>
                              <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='mb-3 text-start form-forgot'>
                                  <label
                                    htmlFor='exampleInputEmail1'
                                    className='form-label'
                                  >
                                    Email address
                                  </label>
                                  <Controller
                                    name='email'
                                    control={control}
                                    render={({
                                      field: { value, onChange },
                                    }) => (
                                      <input
                                        className={`form-control  ${
                                          errors?.email ? 'error-input' : ''
                                        }`}
                                        type='text'
                                        value={value || ''}
                                        onChange={onChange}
                                        autoComplete='false'
                                        placeholder='Enter email'
                                        maxLength={64}
                                      />
                                    )}
                                    defaultValue=''
                                  />
                                  <small className='error-input'>
                                    {errors?.email?.message}
                                  </small>{' '}
                                  {/* <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Email"/> */}
                                  <i className='fa-solid fa-eye-slash'></i>
                                </div>
                                <button
                                  type='submit'
                                  className='btn submit-btn btn-hvr w-100'
                                >
                                  Submit
                                </button>
                                {/* <a href="javascript:;"><i className="fa-solid fa-chevron-left"></i> Back to Login</a> */}
                                <Link to='/auth/login' className=''>
                                  <i className='fa-solid fa-chevron-left'></i>{' '}
                                  Back to Login
                                </Link>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AccessSuccessModal
        setShowModal={setShowModal}
        showModal={showModal}
        content='We sent a OTP to Reg-Email'
        email={Email}
        title='Check your email'
        onOk={onOkayModal}
      />
    </div>
  )
}

export default ForgotPassword
